import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { getFood } from './actions'

import Paper from 'material-ui/Paper';
import {GridList, GridTile} from 'material-ui/GridList';
import {CardTitle} from 'material-ui/Card';
import IconButton from 'material-ui/IconButton';
import Subheader from 'material-ui/Subheader';
import StarBorder from 'material-ui/svg-icons/toggle/star-border';
import TextField from 'material-ui/TextField';

import SessionHeader from '../../components/SessionHeader/SessionHeader'
import ButtonFavorite from '../../components/ButtonFavorite'
import {
  addBookmark,
  deleteBookmark
} from '../Bookmark/actions'
import language from '../../config/language'

const styles = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    paddingBottom: 5    
  },
  gridList: {
    overflowY: 'auto',
  },
};

 class About extends Component {
  state = {
    filterId: 0
  }
  
  componentDidMount() {
  }

  componentWillReceiveProps(nextProps) {
  }
  
  render() {
    const {
      filter,
      textAllFillter
    } = language[this.props.lang]
    return (
      <Paper zDepth={1} style={{
        padding: 10,
        marginTop: 10,
        paddingTop: 1
      }}>
        <div>
          <h1>สำนักงานการท่องเที่ยวและกีฬาจังหวัดพระนครศรีอยุธยา</h1>
          <p>157 สนามกีฬากลางจังหวัดพระนครศรีอยุธยา ต.ไผ่ลิง
          <br />อ.พระนครศรีอยุธยา จ.พระนครศรีอยุธยา 13000
          <br />โทรศัพท์. 035-902719
          <br />โทรสาร. 035-902720</p>
        </div>
      </Paper>
    )
  }
}

const mapStateToProps = ({ lang, category, bookmark, ...state }) => ({
  data: state.food.list[lang].data,
  loading: state.food.list.loading,
  error: state.food.list.error,
  lang,
  category,
  bookmark
})
export default connect(mapStateToProps, {
  getFood,
  addBookmark,
  deleteBookmark
})(About)




// WEBPACK FOOTER //
// ./src/containers/About/About.js